import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { PROFILE_PROXY_ACTION_HAVE_CREDIT, PROFILE_PROXY_ACTION_LABELS, ProfileProxySide } from "@/entities/IProxy";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import type { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { getTimeAgo } from "@/helpers/Helpers";
import { getProfileProxyActionStatus } from "@/helpers/profile-proxy.helpers";
import ProxyActionAcceptanceButton from "../action/ProxyActionAcceptanceButton";
import ProfileProxyCredit from "../action/utils/credit/ProfileProxyCredit";
import ProfileProxyEndTime from "../action/utils/time/ProfileProxyEndTime";
import { PROXY_ACTION_ROW_VIEW_MODE } from "./ProxyActionRow";
import ProxyActionRowStatus from "./ProxyActionRowStatus";
export default function ProxyActionRowDataMode(t0) {
  const $ = _c(49);
  const {
    action,
    profileProxy,
    profile,
    isSelf,
    setViewMode
  } = t0;
  let t1;
  if ($[0] !== action) {
    t1 = getProfileProxyActionStatus({
      action,
      side: ProfileProxySide.GRANTED
    });
    $[0] = action;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const grantorStatus = t1;
  let t2;
  if ($[2] !== action) {
    t2 = getProfileProxyActionStatus({
      action,
      side: ProfileProxySide.RECEIVED
    });
    $[2] = action;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const receiverStatus = t2;
  const t3 = PROFILE_PROXY_ACTION_LABELS[action.action_type];
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="tw-col-span-full md:tw-col-span-2"><div className="tw-flex tw-items-center tw-gap-x-3"><p className="tw-mb-0 tw-text-md tw-font-medium tw-text-iron-50">{t3}</p></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== grantorStatus || $[7] !== profileProxy.created_by) {
    t5 = <ProxyActionRowStatus status={grantorStatus} statusOwnerProfile={profileProxy.created_by} side={ProfileProxySide.GRANTED} />;
    $[6] = grantorStatus;
    $[7] = profileProxy.created_by;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== profileProxy.granted_to || $[10] !== receiverStatus) {
    t6 = <ProxyActionRowStatus status={receiverStatus} statusOwnerProfile={profileProxy.granted_to} side={ProfileProxySide.RECEIVED} />;
    $[9] = profileProxy.granted_to;
    $[10] = receiverStatus;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="tw-col-span-full md:tw-col-span-3"><div className="tw-flex md:tw-flex-col lg:tw-flex-row tw-gap-3">{t5}{t6}</div></div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== action || $[16] !== profileProxy || $[17] !== setViewMode) {
    t8 = PROFILE_PROXY_ACTION_HAVE_CREDIT[action.action_type] && <ProfileProxyCredit profileProxy={profileProxy} profileProxyAction={action} onCreditEdit={() => setViewMode(PROXY_ACTION_ROW_VIEW_MODE.CREDIT_EDIT)} />;
    $[15] = action;
    $[16] = profileProxy;
    $[17] = setViewMode;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <div className="tw-col-span-full md:tw-col-span-2">{t8}</div>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>Start:</span>;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== action.created_at) {
    t11 = getTimeAgo(action.created_at);
    $[22] = action.created_at;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <p className="tw-flex tw-items-center tw-whitespace-nowrap tw-mb-0 tw-space-x-1 tw-text-md tw-font-normal tw-leading-6 tw-text-iron-500">{t10}<span className="tw-text-iron-300 tw-font-normal">{t11}</span></p>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="tw-text-md tw-font-normal tw-text-iron-500">End:</span>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== setViewMode) {
    t14 = () => setViewMode(PROXY_ACTION_ROW_VIEW_MODE.END_TIME_EDIT);
    $[27] = setViewMode;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== action || $[30] !== profileProxy || $[31] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-space-x-1">{t13}<ProfileProxyEndTime profileProxy={profileProxy} profileProxyAction={action} onEndTimeEdit={t14} /></div>;
    $[29] = action;
    $[30] = profileProxy;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t15) {
    t16 = <div className="tw-col-span-full md:tw-col-span-4"><div className="tw-flex md:tw-flex-col lg:tw-flex-row tw-gap-y-3 tw-gap-x-6">{t12}{t15}</div></div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== action || $[37] !== isSelf || $[38] !== profile || $[39] !== profileProxy) {
    t17 = isSelf && <ProxyActionAcceptanceButton action={action} profile={profile} profileProxy={profileProxy} />;
    $[36] = action;
    $[37] = isSelf;
    $[38] = profile;
    $[39] = profileProxy;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17) {
    t18 = <div className="tw-col-span-full md:tw-col-span-2">{t17}</div>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t16 || $[44] !== t18 || $[45] !== t4 || $[46] !== t7 || $[47] !== t9) {
    t19 = <div className="xl:tw-h-14 tw-relative tw-grid tw-grid-cols-[repeat(13,minmax(0,1fr))] tw-gap-y-3 tw-gap-x-4 tw-justify-between lg:tw-items-center tw-w-full tw-py-4 xl:tw-py-0 tw-px-4">{t4}{t7}{t9}{t16}{t18}</div>;
    $[43] = t16;
    $[44] = t18;
    $[45] = t4;
    $[46] = t7;
    $[47] = t9;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
}